import { SongDetailContainer } from "./SongDetailContainer.component";

export default SongDetailContainer;
